import React, { useState, useEffect } from 'react';
import {
  Edit,
  SimpleForm,
  FileInput,
  ImageField,
  useUpdate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

// Componente para previsualizar el archivo actual o el nuevo
const MediaPreviewEdit = ({ record, fileChanged }: { record?: any, fileChanged: boolean }) => {
  if (!record) return null;
  // Si cambió usamos 'src', si no usamos la 'url' que viene de Strapi
  const src = fileChanged ? record.src : record.url;
  const isVideo = record.rawFile?.type.includes('video') || record.mime?.includes('video') || src?.includes('.mp4');

  if (isVideo) {
    return (
      <video key={src} controls width="300" style={{ borderRadius: '8px', marginTop: '10px' }}>
        <source src={src} type={record.rawFile?.type || 'video/mp4'} />
      </video>
    );
  }
  return <ImageField source={fileChanged ? "src" : "url"} title="title" />;
};

function QuienesSomosEdit(props: any) {
  const [fileChanged, setFileChanged] = useState(false);
  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-quienes-somoss';

  useEffect(() => {
    document.title = 'Editar Quiénes Somos';
  }, []);

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      const payload: Record<string, any> = { descripcion: data.descripcion };

      if (fileChanged && data.videoUrl?.rawFile) {
        const up = await uploadImage(data.videoUrl.rawFile, token!);
        payload.videoUrl = { id: up.id };
      }

      update(resourceName, { id: data.id, data: payload }, {
        onSuccess: () => {
          notify('Actualizado con éxito');
          redirect('list', resourceName);
        }
      });
    } catch (e) {
      notify('Error al actualizar', { type: 'error' });
    }
  };

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput 
          source="descripcion" 
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="videoUrl" label="Cambiar Video" onChange={() => setFileChanged(true)}>
          <MediaPreviewEdit fileChanged={fileChanged} />
        </FileInput>
      </SimpleForm>
    </Edit>
  );
}

export default QuienesSomosEdit;